// src/components/Projects/Project.js
import React from "react";
import "./Projects.css";

const Project = ({ title, location, dates, description, video, imageMobile, imageDesktop, isReversed }) => {
  return (
    <article
      className={`project-card ${
        isReversed ? "project-card--reverse" : ""
      }`}
    >
      <div className="project-media">
        {video ? (
          <video
            className="project-video"
            src={video}
            controls
            controlsList="nodownload"
            loop
          />
        ) : (
          <picture>
            {/* Desktop */}
            <source
              media="(min-width: 900px)"
              srcSet={imageDesktop}
            />

            {/* Mobile fallback */}
            <img
              className="project-image"
              src={imageMobile}
              alt={title}
            />
          </picture>
        )}
      </div>

      <div className="project-content">
        <h3 className="project-title">{title}</h3>
        <p className="project-meta">
          <span>{location}</span> • <span>{dates}</span>
        </p>
        <p className="project-description">{description}</p>
      </div>
    </article>
  );
};

export default Project;